import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon, File02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Loader } from "shared/components/Loader";
import { Show } from "shared/components";

// A file staged in the composer: shown while it uploads (spinner overlay) and
// after (removable). Images get a local thumbnail; other files a labelled card.
export interface PendingAttachment {
  key: string;
  id?: string;
  filename: string;
  isImage: boolean;
  previewUrl?: string;
  status: "uploading" | "done";
}

const fileTypeLabel = (filename: string) => {
  const ext = filename.split(".").pop();
  return ext && ext !== filename ? ext.toUpperCase() : "File";
};

export const PendingAttachmentPreview = ({
  attachments,
  onRemove
}: {
  attachments: PendingAttachment[];
  onRemove: (key: string) => void;
}) => (
  <div className="flex flex-wrap gap-3">
    {attachments.map((a) => (
      <div key={a.key} className="group relative">
        {a.isImage && a.previewUrl ? (
          <img
            src={a.previewUrl}
            alt={a.filename}
            className="h-16 w-16 rounded-lg border border-alpha-100 object-cover"
          />
        ) : (
          <div className="flex h-16 w-[220px] items-center gap-3 rounded-lg border border-alpha-100 bg-alpha-40 px-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-danger-500 text-white">
              <HugeiconsIcon icon={File02Icon} size={20} />
            </div>
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-content-1000">
                {a.filename}
              </p>
              <p className="text-xs font-medium text-content-300">
                {fileTypeLabel(a.filename)}
              </p>
            </div>
          </div>
        )}
        <Show if={a.status === "uploading"}>
          <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-alpha-800">
            <Loader />
          </div>
        </Show>
        <Show if={a.status === "done"}>
          <button
            type="button"
            aria-label="Remove attachment"
            onClick={() => onRemove(a.key)}
            className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border border-alpha-100 bg-white text-content-500 shadow-sm hover:text-content-1000"
          >
            <HugeiconsIcon icon={Cancel01Icon} size={12} />
          </button>
        </Show>
      </div>
    ))}
  </div>
);
